export default __webpack_public_path__ + "static/media/AttackingPrisons.39285f03.pdf";